module.exports = __webpack_public_path__ + "img/canbadge-round-38mm-glitter.b77ea834.png";